import { render, staticRenderFns } from "./WaterMark.vue?vue&type=template&id=783c8aa7&scoped=true"
import script from "./WaterMark.vue?vue&type=script&lang=js"
export * from "./WaterMark.vue?vue&type=script&lang=js"
import style0 from "./WaterMark.vue?vue&type=style&index=0&id=783c8aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783c8aa7",
  null
  
)

export default component.exports